export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14784.932d8eb6.jpg";